exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.balanceBlock[data-v-66f2a70a] {\n    display: -webkit-box;\n    display: flex;\n    -webkit-box-pack: justify;\n            justify-content: space-between;\n}\n.forthing-table[data-v-66f2a70a] {\n    border-collapse: separate;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n    overflow: hidden;\n}\n.center-items[data-v-66f2a70a] {\n    width: 100%;\n    margin: 0 auto;\n}\n.forthing-history-button-label[data-v-66f2a70a] {\n    white-space: nowrap;\n}\n.aube_user_wallet_check_color[data-v-66f2a70a] {\n   color: #450080;\n}\n.hec_saving_check_color[data-v-66f2a70a] {\n   color: #00ad69;\n}\n", ""]);

// exports
